import { USERS as userTypes } from '../mutation-types';

if (!window.dataLayer) {
  window.dataLayer = [];
}

// State
//
// グローバル変数tom.userの値はpug側で埋め込んで渡されている
// @see views/shop/details.pug
// ```
// script.
//   tom.user.willJoinPremium = #{willJoinPremium};
//   tom.user.hasWaitingAutoRecurringPremium = #{hasWaitingAutoRecurringPremium};
// ```
const userId = window.dataLayer.find((d) => d.userId);
const state = () => ({
  _id: (userId && userId.userId) || '',
  is_login: tom.conf.isLogin,
  is_verified: tom.user.isVerified,
  lang: tom.conf.lang,
  csrf: tom.conf.csrfToken,
  is_smart_phone_device: tom.user.isSmartPhoneDevice,
  is_new_customer: tom.user.isNewCustomer,
  has_welcoming_gift_coupon: tom.user.hasWelcomingGiftCoupon,
  is_premium_member: tom.user.isPremiumMember,
  will_join_premium: tom.user.willJoinPremium,
  has_waiting_auto_recurring_premium: tom.user.hasWaitingAutoRecurringPremium,
  had_registered_premium_in_past: tom.user.hadRegisteredPremiumInPast,
  possible_premium_plan: tom.user.possiblePremiumPlan,
  possible_premium_plan_type: tom.user.possiblePremiumPlanType,
  current_subscription_id: tom.user.currentSubscriptionId,
  can_buy_with_annual_plan: tom.user.canBuyWithAnnualPlan,
  can_gain_recontract_extra_point: tom.user.canGainRecontractExtraPoint,
  minimum_subtotal_for_recontract_extra_point: tom.user.minimumSubtotalForRecontractExtraPoint,
  recontract_extra_point: tom.user.recontractExtraPoint,
  remain_subtotal_for_recontract_extra_point: tom.user.remainSubtotalForRecontractExtraPoint,
  // アイテム詳細画面でのみ設定しているのでその他の画面では正しく参照出来ない
  is_cart_empty: tom.user.isCartEmpty,
  channel_id: tom.user.channelId,
  // Premium会員になることで復活できるポイント
  revivable_right: null,
  point_account: {
    point_to_dollar: tom.user.pointAccount && tom.user.pointAccount.pointToDollar
  }
});
// Actions
const actions = {
  /*
  Change flag to join TOM Premium
  @param {Object} payload
  @param {Boolean} payload.join
  */
  willJoinPremium({
    commit,
    state
  }, payload = {}) {
    if (payload.join === undefined || payload.join === null) {
      payload.join = !state.will_join_premium;
    }
    commit(userTypes.TOGGLE_WILL_JOIN_PREMIUM, payload);
  },

  hasWaitingAutoRecurringPremium({
    commit
  }, payload = {}) {
    commit(userTypes.SET_HAS_WAITING_AUTO_RECURRING_PREMIUM, payload);
  },

  possiblePremiumPlanType({
    commit
  }, payload = {}) {
    commit(userTypes.SET_POSSIBLE_PREMIUM_PLAN_TYPE, payload);
  },

  // Premium会員になることで復活できるポイント
  setRevivableRight({
    commit
  }, payload = {}) {
    commit(userTypes.SET_REVIVABLE_RIGHT, payload);
  },

  hadRegisteredPremiumInPast({
    commit
  }, payload = {}) {
    commit(userTypes.SET_HAD_REGISTERED_PREMIUM_IN_PAST, payload);
  },

  setChannelId({
    commit
  }, payload = {}) {
    commit(userTypes.SET_CHANNEL_ID, payload);
  },

  canBuyWithAnnualPlan({
    commit
  }, payload = {}) {
    commit(userTypes.SET_CAN_BUY_WITH_ANNUAL_PLAN, payload);
  },

  currentSubscriptionId({
    commit
  }, payload = {}) {
    commit(userTypes.SET_CURRENT_SUBSCRIPTION_ID, payload);
  }
};

// Mutations
const mutations = {
  [userTypes.TOGGLE_WILL_JOIN_PREMIUM](state, payload) {
    state.will_join_premium = payload.join;
  },
  [userTypes.SET_HAS_WAITING_AUTO_RECURRING_PREMIUM](state, payload) {
    state.has_waiting_auto_recurring_premium =
      payload.has_waiting_auto_recurring_premium;
  },
  [userTypes.SET_POSSIBLE_PREMIUM_PLAN_TYPE](state, payload) {
    state.possible_premium_plan_type = payload.possible_premium_plan_type;
  },
  [userTypes.SET_REVIVABLE_RIGHT](state, payload) {
    state.revivable_right = payload.revivable_right;
  },
  [userTypes.SET_HAD_REGISTERED_PREMIUM_IN_PAST](state, payload) {
    state.had_registered_premium_in_past =
      payload.had_registered_premium_in_past;
  },
  [userTypes.SET_CHANNEL_ID](state, payload) {
    state.channel_id = payload.channel_id;
  },
  [userTypes.SET_CURRENT_SUBSCRIPTION_ID](state, payload) {
    state.current_subscription_id = payload.current_subscription_id;
  },
  [userTypes.SET_CAN_BUY_WITH_ANNUAL_PLAN](state, payload) {
    state.can_buy_with_annual_plan = payload.can_buy_with_annual_plan;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
